module.exports = __webpack_public_path__ + "img/HealthBG.7f306127.jpg";